import { gql } from "@apollo/client";

const NEW_CONSULTATION_PRODUCT = gql`
  mutation newConsultationProduct($input: ConsultationInput!) {
    newConsultationProduct(input: $input) {
      __typename
      ... on ConsultationProduct {
        id
        message
        response
        product_id
        user_id
      }
      ... on ResultError {
        status_code
        message
      }
    }
  }
`;

const NEW_RESPONSE_PRODUCT = gql`
  mutation newResponseProduct($input: ResponseInput!) {
    newResponseProduct(input: $input) {
      __typename
      ... on ConsultationProduct {
        id
        message
        response
        product_id
        user_id
      }
      ... on ResultError {
        status_code
        message
      }
    }
  }
`;

export { NEW_CONSULTATION_PRODUCT, NEW_RESPONSE_PRODUCT };
